import { Cookies } from "react-cookie";
import {
  GetAllNotification,
  OfferLetterApprovalPayload,
  OfferLetterSignedListPayload,
  SeenNotificationPayload,
  userDetails,
} from "../../models/userModels";
import {
  getAllNotificationListService,
  LoginService,
  LogoutService,
  offerLetterSignedListService,
  resetPasswordService,
  seenNotificationService,
  SignedOfferLetterApprovalListService,
  getApkDownloadUrlService,
} from "../../services/userServices";
import { ApiCallErrorAction, BeginApiCallAction, StopLoadingAction } from "./apiStatusActions";
import { IResetPassword } from "../../interfaces/projectDashboard.interface";

export enum UserActionTypes {
  Logout_Success_Action = "[USER] Logout Success Action",
  User_Login_Success_Action = "[USER] User Login Success Action",
  Side_nav_Auto_Close_Open = "[USER] Side Nav Auto Close Open",
  Get_All_Notification_Success_Action = "[USER] Get All Notification Success Action",
  Seen_Notification_Success_Action = "[USER] Seen Notification Success Action",
  Offer_Letter_Listing_Success_Action = "[USER] Offer Letter Listing Success Action",
  Offer_Letter_Signed_Approval_Success_Action = "[USER] Offer Letter Signed Approval Success Action",
  Reset_Password_Success_action = "[USER] Reset password sucess action",
  Set_IPhone_Mode_Action = "[USER] Set IPhone Mode Action",
}

export const logoutSuccessAction = () => {
  return { type: UserActionTypes.Logout_Success_Action };
};

export const LogOutAction = (): any => {
  return (dispatch: any, getState: any) => {
    const token = getState().user?.userDetails?.accessToken;
    if (token) {
      LogoutService().catch((error) => {
        console.error("Logout API call failed:", error);
      });
    }
    try {
      const cook = new Cookies();
      cook.remove("iphone_mode", { path: "/" });
      cook.remove("user", { path: "/" });
      localStorage.removeItem("user");
      localStorage.removeItem("iphone_mode");
    } catch (e) {
      console.error("Error removing cookies on logout:", e);
    }
    dispatch(logoutSuccessAction());
  };
};

export const SetIPhoneModeAction = (mode?: "attendance" | "other_operations"): any => {
  return (dispatch: any) => {
    try {
      const cook = new Cookies();
      if (mode) {
        cook.set("iphone_mode", mode, { path: "/", maxAge: 365 * 24 * 60 * 60 });
        localStorage.setItem("iphone_mode", mode);
      } else {
        cook.remove("iphone_mode", { path: "/" });
        localStorage.removeItem("iphone_mode");
      }
    } catch (e) {
      console.error("Error updating iphone_mode cookie:", e);
    }
    dispatch({ type: UserActionTypes.Set_IPhone_Mode_Action, payload: mode });
  };
};

export const UserLoginAction = (data: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Signing in. Please Wait...",
        type: 2,
      })
    );
    return LoginService(data)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
          throw new Error(response.data?.message || "Login failed");
        } else {
          if (!response.data?.is_reset_password) {
            const cook = new Cookies();
            cook.set("user", response.data, { path: "/" });
            try {
              localStorage.setItem("user", JSON.stringify(response.data));
            } catch (e) {
              console.error("Error saving user to localStorage:", e);
            }
          }
          dispatch(userLoginSuccessAction(response.data));
          return response.data;
        }
      })
      .catch((error) => {
        const backendMessage =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          (typeof error?.response?.data === "string" ? error.response.data : undefined);

        if (error.response?.status === 401) {
          dispatch(
            ApiCallErrorAction({
              errorCode: error?.response?.data?.errorCode || "",
              message: backendMessage || "Please Login again to continue.",
            })
          );
          dispatch(LogOutAction());
        } else if (error.response?.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: error?.response?.data?.errorCode || "",
              message: backendMessage || "Internal Server Error. Please try again later.",
            })
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: error?.response?.data?.errorCode || "",
              message: backendMessage || "Error encountered please try again later",
            })
          );
        }
        throw error;
      });
  };
};

export const userLoginSuccessAction = (payload: userDetails) => {
  return { type: UserActionTypes.User_Login_Success_Action, payload: payload };
};

export const updateUserFaceImageAction = (imageUrl: string): any => {
  return (dispatch: any, getState: any) => {
    const currentUser = getState().user?.userDetails;
    if (currentUser) {
      const updatedUser = {
        ...currentUser,
        imageSingUrl: imageUrl,
        employee_detail: currentUser.employee_detail ? {
          ...currentUser.employee_detail,
          imageSingUrl: imageUrl,
          employee_image: imageUrl
        } : currentUser.employee_detail
      };
      
      const cook = new Cookies();
      cook.set("user", updatedUser, { path: "/" });
      try {
        localStorage.setItem("user", JSON.stringify(updatedUser));
      } catch (e) {
        console.error("Error saving updated user image to localStorage:", e);
      }
      
      dispatch(userLoginSuccessAction(updatedUser));
      return updatedUser;
    }
  };
};

export const SidenavAutoCloseOpen = (payload: boolean) => {
  return { type: UserActionTypes.Side_nav_Auto_Close_Open, payload: payload };
};

export const ResetPasswordSuccessAction = (payload: any) => {
  return { type: UserActionTypes.Reset_Password_Success_action, payload: payload };
};

export const resetPasswordAction =
  (userBody: any, enqueSnack: any) => (dispatch: any, getState: any) => {
    // console.log("action called : ", userBody);
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Resetting your password. Please Wait...",
        type: 2,
      })
    );
    return resetPasswordService(userBody)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        }
        else {
          dispatch(ResetPasswordSuccessAction(response.data));
          dispatch(LogOutAction());
          enqueSnack.enqueueSnackbar("password reset successfully", {
            variant: "success",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
        }
      })
      .catch((error) => {
        const backendMessage =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          (typeof error?.response?.data === "string" ? error.response.data : undefined);

        if (error.response?.status === 401) {
          dispatch(
            ApiCallErrorAction({
              errorCode: error?.response?.data?.errorCode || "",
              message: backendMessage || "Please Login again to continue.",
            })
          );
          dispatch(LogOutAction());
        } else if (error.response?.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: error?.response?.data?.errorCode || "",
              message: backendMessage || "Internal Server Error. Please try again later.",
            })
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: error?.response?.data?.errorCode || "",
              message: backendMessage || "Error encountered please try again later",
            })
          );
        }
      });
  };

export const GetAllNotificationAction = () => {
  return (dispatch: any, getState: any) => {
    // dispatch(
    //   BeginApiCallAction({
    //     count: 1,
    //     message: "Get All Notification. Please Wait...",
    //     type: 2,
    //   })
    // );
    return getAllNotificationListService()
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(GetAllNotificationSuccessAction(response.data));
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            })
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            })
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            })
          );
        }
      });
  };
};
export const GetAllNotificationSuccessAction = (data: GetAllNotification) => {
  return {
    type: UserActionTypes.Get_All_Notification_Success_Action,
    payload: data,
  };
};

export const SeenNotificationAction = ({
  payload,
  successCallBack,
}: {
  payload: SeenNotificationPayload;
  successCallBack?: any;
}) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Seen Notification. Please Wait...",
        type: 2,
      })
    );
    return seenNotificationService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          successCallBack?.(response.data);
          dispatch(SeenNotificationSuccessAction(response.data));
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            })
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            })
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            })
          );
        }
      });
  };
};
export const SeenNotificationSuccessAction = (data: any) => {
  return {
    type: UserActionTypes.Seen_Notification_Success_Action,
    payload: data,
  };
};
export const OfferLetterListingAction = ({
  payload,
  successCallBack,
}: {
  payload: OfferLetterSignedListPayload;
  successCallBack?: any;
}) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Offer Letter Listing. Please Wait...",
        type: 2,
      })
    );
    return offerLetterSignedListService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(OfferLetterListingSuccessAction(response.data));
          successCallBack?.(response.data);
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            })
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            })
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            })
          );
        }
      });
  };
};
export const OfferLetterListingSuccessAction = (data: any) => {
  return {
    type: UserActionTypes.Offer_Letter_Listing_Success_Action,
    payload: data,
  };
};
export const OfferLetterSignedApprovalAction = ({
  payload,
  successCallBack,
}: {
  payload: OfferLetterApprovalPayload;
  successCallBack?: any;
}) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Offer Letter Approval. Please Wait...",
        type: 2,
      })
    );
    return SignedOfferLetterApprovalListService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(OfferLetterSignedApprovalSuccessAction(response.data));
          successCallBack?.(response.data);
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies();
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Please Login again to continue.",
            })
          );
          cook.remove("user", { path: "/" });
          dispatch(LogOutAction());
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: error?.response?.data?.message,
            })
          );
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: "",
              message: "Error encountered please try again later",
            })
          );
        }
      });
  };
};
export const OfferLetterSignedApprovalSuccessAction = (data: any) => {
  return {
    type: UserActionTypes.Offer_Letter_Signed_Approval_Success_Action,
    payload: data,
  };
};

export const getApkDownloadUrlAction = () => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: "Fetching secure APK download link...",
        type: 2,
      })
    );
    return getApkDownloadUrlService()
      .then((response) => {
        dispatch(StopLoadingAction());
        return response;
      })
      .catch((error) => {
        dispatch(StopLoadingAction());
        throw error;
      });
  };
};